/* bek-infinite-scroll.js (Claude, 2026-10-01)
   Nachladen beim Scrollen fuer Kategorien mit Familienkacheln.
   Startseite liefert 48 Produkte, weitere Pakete kommen ueber die Section Rendering API.
   Die normale Seitennavigation bleibt im HTML (Crawler, Fallback) und wird nur ausgeblendet.
   Kacheln stehen zwischen <template data-bek-tile> und <template data-bek-tile-end>;
   data-pos = Anzahl regulaerer Karten davor, data-fallback = Kachel stand hinter den Karten
   des Pakets und wird an ihre Position verschoben, sobald genug Karten da sind. */
(function () {
  if (window.__bekInfInit) return;
  window.__bekInfInit = true;

  var STORE = 'bekInf:';
  var MARGIN = 2000;
  var st = null;

  function injectCss() {
    if (document.getElementById('bek-inf-css')) return;
    var s = document.createElement('style');
    s.id = 'bek-inf-css';
    s.textContent = 'nav.pagination.bek-inf-active{display:none!important}' +
      '.bek-inf-sentinel{display:block;width:100%;height:1px}' +
      '.bek-inf-live{position:absolute!important;width:1px;height:1px;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;padding:0}';
    document.head.appendChild(s);
  }

  function gridIn(root) {
    return root ? root.querySelector('.collection-grid__wrapper > .grid') : null;
  }

  function cardList(grid) {
    var out = [];
    for (var i = 0; i < grid.children.length; i++) {
      if (grid.children[i].classList.contains('grid-product')) out.push(grid.children[i]);
    }
    return out;
  }

  function isMarker(n, attr) {
    return !!n && n.nodeType === 1 && n.tagName === 'TEMPLATE' && n.hasAttribute(attr);
  }

  function readGroup(kids, i) {
    var m = kids[i];
    var g = {
      id: m.getAttribute('data-bek-tile') || '',
      pos: parseInt(m.getAttribute('data-pos') || '0', 10) || 0,
      fallback: m.hasAttribute('data-fallback'),
      nodes: [m],
      end: i
    };
    for (var j = i + 1; j < kids.length; j++) {
      g.nodes.push(kids[j]);
      g.end = j;
      if (isMarker(kids[j], 'data-bek-tile-end')) break;
    }
    return g;
  }

  function groupsIn(grid) {
    var groups = [];
    var kids = Array.prototype.slice.call(grid.childNodes);
    for (var i = 0; i < kids.length; i++) {
      if (isMarker(kids[i], 'data-bek-tile')) {
        var g = readGroup(kids, i);
        groups.push(g);
        i = g.end;
      }
    }
    return groups;
  }

  function sortHeld() {
    st.held.sort(function (a, b) { return a.pos - b.pos; });
  }

  function placeHeld(final) {
    if (!st || !st.held.length) return;
    var cards = cardList(st.grid);
    var last = {};
    while (st.held.length && cards.length >= st.held[0].pos) {
      var g = st.held.shift();
      var ref = null;
      if (last[g.pos]) {
        ref = last[g.pos].nextSibling;
      } else if (g.pos === 0) {
        ref = cards.length ? cards[0] : null;
      } else {
        ref = cards[g.pos - 1].nextSibling;
      }
      for (var i = 0; i < g.nodes.length; i++) st.grid.insertBefore(g.nodes[i], ref);
      last[g.pos] = g.nodes[g.nodes.length - 1];
    }
    if (final && st.held.length) {
      // Wie die Rueckfall-Schleife in bek-family-grid: Kacheln, deren Position nicht
      // erreicht wird, stehen am Ende in der Reihenfolge der Kachel-Liste.
      var rest = st.held.splice(0, st.held.length).sort(function (a, b) { return a.idx - b.idx; });
      for (var r = 0; r < rest.length; r++) {
        for (var k = 0; k < rest[r].nodes.length; k++) st.grid.appendChild(rest[r].nodes[k]);
      }
    }
  }

  function ensureLink(n) {
    var href = n.getAttribute('href');
    if (!href) return;
    var path = href.split('?')[0];
    var links = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      if ((links[i].getAttribute('href') || '').split('?')[0] === path) return;
    }
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  function ensureScript(n) {
    var src = n.getAttribute('src');
    if (!src) return;
    if (src.indexOf('bek-lefeu-eye') > -1 && window.__bekEyeInit) return;
    var path = src.split('?')[0];
    var scripts = document.querySelectorAll('script[src]');
    for (var i = 0; i < scripts.length; i++) {
      if ((scripts[i].getAttribute('src') || '').split('?')[0] === path) return;
    }
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    document.body.appendChild(s);
  }

  function appendFrom(g) {
    var frag = document.createDocumentFragment();
    var kids = Array.prototype.slice.call(g.childNodes);
    var added = 0;
    for (var i = 0; i < kids.length; i++) {
      var n = kids[i];
      if (isMarker(n, 'data-bek-tile')) {
        // Kacheln aus spaeteren Paketen (nur mit Filter) an ihre Gesamtposition setzen.
        var grp = readGroup(kids, i);
        i = grp.end;
        if (grp.id && st.seen[grp.id]) continue;
        if (grp.id) st.seen[grp.id] = true;
        grp.nodes = grp.nodes.map(function (x) { return document.importNode(x, true); });
        grp.idx = st.seq++;
        st.held.push(grp);
        continue;
      }
      if (n.nodeType === 1 && n.tagName === 'LINK') { ensureLink(n); continue; }
      if (n.nodeType === 1 && n.tagName === 'SCRIPT') { ensureScript(n); continue; }
      if (n.nodeType === 1 && n.classList.contains('grid-product')) added++;
      frag.appendChild(document.importNode(n, true));
    }
    st.grid.appendChild(frag);
    sortHeld();
    return added;
  }

  function announce(text) {
    if (st && st.live) st.live.textContent = text;
  }

  function showNav() {
    if (!st) return;
    st.nav.classList.remove('bek-inf-active');
    placeHeld(true);
  }

  function abort(my) {
    if (st !== my || my.dead) return;
    my.dead = true;
    if (my.io) my.io.disconnect();
    showNav();
  }

  function refreshTheme() {
    try {
      if (window.theme && typeof theme.reinitProductGridItem === 'function') theme.reinitProductGridItem();
    } catch (e) {}
    try {
      if (window.AOS && typeof AOS.refreshHard === 'function') AOS.refreshHard();
    } catch (e) {}
  }

  function processHtml(my, html) {
    if (st !== my || my.dead) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var g = gridIn(doc);
    var nav = doc.querySelector('nav.pagination[data-bek-infinite]');
    var added = g ? appendFrom(g) : 0;
    my.page = nav ? parseInt(nav.getAttribute('data-page'), 10) : my.page + 1;
    my.next = nav ? (nav.getAttribute('data-next') || '') : '';
    if (my.page >= my.pages) my.next = '';
    placeHeld(!my.next);
    refreshTheme();
    if (added) announce(added + ' weitere Produkte geladen');
    if (!my.next) {
      announce('Alle Produkte geladen');
      if (my.io) my.io.disconnect();
    }
    if (my.restoreTo && (my.page >= my.restoreTo.pages || !my.next)) {
      var y = my.restoreTo.y;
      my.restoreTo = null;
      setTimeout(function () { window.scrollTo(0, y); }, 30);
    }
  }

  function pageUrl(my, k) {
    var u = new URL(my.next || window.location.href, window.location.origin);
    u.searchParams.set(my.param, String(k));
    u.searchParams.set('section_id', my.section);
    return u.toString();
  }

  function fetchPage(my, k, tries) {
    return fetch(pageUrl(my, k), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).catch(function (err) {
      if (st !== my || my.dead || tries <= 1) throw err;
      return new Promise(function (res) { setTimeout(res, 1500 * (4 - tries)); }).then(function () {
        return fetchPage(my, k, tries - 1);
      });
    });
  }

  function nearSentinel(my) {
    return !!my.sentinel && my.sentinel.getBoundingClientRect().top < window.innerHeight + MARGIN;
  }

  function loadNext() {
    var my = st;
    if (!my || my.dead || my.loading || my.loadingAll || !my.next) return;
    my.loading = true;
    fetchPage(my, my.page + 1, 3).then(function (html) {
      if (st !== my) return;
      my.loading = false;
      processHtml(my, html);
      if (my.next && nearSentinel(my)) setTimeout(loadNext, 50);
    }, function () {
      if (st !== my) return;
      my.loading = false;
      abort(my);
    });
  }

  function loadAll() {
    var my = st;
    if (!my || my.dead || my.loadingAll || !my.next) return;
    my.loadingAll = true;
    if (my.io) my.io.disconnect();
    var queue = [];
    var results = {};
    var nextToAppend = my.page + 1;
    for (var k = my.page + 1; k <= my.pages; k++) queue.push(k);

    function drain() {
      while (st === my && !my.dead && Object.prototype.hasOwnProperty.call(results, nextToAppend)) {
        var html = results[nextToAppend];
        delete results[nextToAppend];
        if (html === null) { abort(my); return; }
        processHtml(my, html);
        nextToAppend++;
      }
    }

    function worker() {
      if (st !== my || my.dead || !queue.length) return;
      var page = queue.shift();
      fetchPage(my, page, 3).then(function (html) {
        results[page] = html;
      }, function () {
        results[page] = null;
      }).then(function () {
        drain();
        worker();
      });
    }

    worker();
    worker();
  }

  function saveState() {
    if (!st) return;
    try {
      sessionStorage.setItem(STORE + window.location.pathname + window.location.search, JSON.stringify({
        pages: st.page,
        y: window.pageYOffset || 0,
        t: Date.now()
      }));
    } catch (e) {}
  }

  function readRestore() {
    var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (!nav || nav.type !== 'back_forward') return null;
    try {
      var key = STORE + window.location.pathname + window.location.search;
      var v = JSON.parse(sessionStorage.getItem(key) || 'null');
      sessionStorage.removeItem(key);
      if (v && v.pages > 1 && Date.now() - v.t < 1800 * 1000) return v;
    } catch (e) {}
    return null;
  }

  function init() {
    if (st && st.io) st.io.disconnect();
    st = null;
    var root = document.getElementById('CollectionAjaxContent');
    var nav = root ? root.querySelector('nav.pagination[data-bek-infinite]') : null;
    var grid = gridIn(root);
    if (!nav || !grid || !nav.getAttribute('data-next') || !window.fetch || !window.DOMParser) return;
    injectCss();
    st = {
      nav: nav,
      grid: grid,
      next: nav.getAttribute('data-next'),
      page: parseInt(nav.getAttribute('data-page') || '1', 10),
      pages: parseInt(nav.getAttribute('data-pages') || '1', 10),
      param: nav.getAttribute('data-param') || 'page',
      section: nav.getAttribute('data-section'),
      held: [],
      seen: {},
      seq: 0,
      loading: false,
      loadingAll: false,
      dead: false
    };
    var count = cardList(grid).length;
    groupsIn(grid).forEach(function (g) {
      if (g.id) st.seen[g.id] = true;
      if (g.fallback && g.pos > count) {
        g.nodes.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
        g.idx = st.seq++;
        st.held.push(g);
      }
    });
    sortHeld();
    nav.classList.add('bek-inf-active');

    st.live = document.createElement('div');
    st.live.className = 'bek-inf-live';
    st.live.setAttribute('aria-live', 'polite');
    st.live.setAttribute('role', 'status');
    st.sentinel = document.createElement('div');
    st.sentinel.className = 'bek-inf-sentinel';
    st.sentinel.setAttribute('aria-hidden', 'true');
    grid.parentNode.insertBefore(st.sentinel, grid.nextSibling);
    grid.parentNode.insertBefore(st.live, st.sentinel.nextSibling);

    st.restoreTo = readRestore();
    if (st.restoreTo) {
      try { history.scrollRestoration = 'manual'; } catch (e) {}
    }

    if (st.held.length || st.restoreTo || !('IntersectionObserver' in window)) {
      loadAll();
    } else {
      var my = st;
      my.io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { loadNext(); break; }
        }
      }, { rootMargin: '0px 0px ' + MARGIN + 'px 0px' });
      my.io.observe(my.sentinel);
      // Sicherheitsnetz: Sprung ans Seitenende (Ende-Taste, Scrollbalken) ohne IO-Meldung.
      window.addEventListener('scroll', function onScroll() {
        if (st !== my || !my.next || my.dead) {
          window.removeEventListener('scroll', onScroll);
          return;
        }
        if (!my.loading && !my.ticking) {
          my.ticking = true;
          setTimeout(function () {
            my.ticking = false;
            if (st === my && nearSentinel(my)) loadNext();
          }, 200);
        }
      }, { passive: true });
    }
  }

  document.addEventListener('click', function (e) {
    if (!st) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a && st.grid.contains(a)) saveState();
  }, true);
  document.addEventListener('collection:reloaded', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();